import { api } from '@services';

import TagCategory, {
  CategoryColor,
  ITagCategory,
  ITagCategoryApiModel,
} from '@models/TagCategory.model';

interface IUpdateEquipmentStatus {
  id: string;
  name?: string;
  isUnique?: boolean;
  showOnOnboard?: boolean;
  description?: string;
  color: CategoryColor;
}

const updateTagCategory = async ({
  id,
  ...data
}: IUpdateEquipmentStatus): Promise<ITagCategory> => {
  const { data: tagCategory } = await api.patch<ITagCategoryApiModel>(
    `/tagsCategory/${id}`,
    data,
  );

  return TagCategory.fromApiModel(tagCategory);
};

export { updateTagCategory };
